/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DataLoader } from '../models/DataLoader';
import type { DataLoaderLoadingStatus } from '../models/DataLoaderLoadingStatus';
import type { DataLoaderStatus } from '../models/DataLoaderStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FileService {

    /**
     * Returns list of files
     * @returns any Success
     * @throws ApiError
     */
    public static getFilesList({
        sort,
        limit,
        offset,
        ignorePagination,
    }: {
        /**
         * Sort parameters
         */
        sort?: Record<string, any>,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        ignorePagination?: boolean,
    }): CancelablePromise<{
        rows: Array<DataLoader>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/file',
            query: {
                'sort': sort,
                'limit': limit,
                'offset': offset,
                'ignorePagination': ignorePagination,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Upload customer file
     * @returns any Success
     * @throws ApiError
     */
    public static uploadFile({
        formData,
    }: {
        formData: {
            file?: Blob;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/file',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns pre-signed url to upload file to S3
     * @returns any Success
     * @throws ApiError
     */
    public static getSignedUrlForUpload({
        requestBody,
    }: {
        requestBody: {
            filename?: string;
            fileSize?: number;
            type?: string;
            comment?: string;
            vendor?: string;
        },
    }): CancelablePromise<{
        url: string;
        dataLoader: DataLoader;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/file/signed-url',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update status for uploading
     * @returns DataLoader Success
     * @throws ApiError
     */
    public static updateFileUpload({
        fileId,
        requestBody,
    }: {
        /**
         * DataLoader id
         */
        fileId: number,
        requestBody: {
            status?: DataLoaderStatus;
            error?: string | null;
            errorData?: string | null;
            loadingStatus?: DataLoaderLoadingStatus;
        },
    }): CancelablePromise<DataLoader> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/file/{fileId}',
            path: {
                'fileId': fileId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
